export default function lowerCase (input) {
    if (!input) return ''
    input = input.toString()
    return input.toLowerCase()
}